/* eslint-disable  react/display-name */
import { Grid, IconButton, Tooltip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PCheck from "../../../../components/pos/PCheck";
import PSelect from "../../../../components/pos/PSelect";
import PText from "../../../../components/pos/PText";
import db from "../../../../db/db";
import MUIDataTable from "mui-datatables";
import React, { useEffect, useState } from "react";
import BarcodeReader from "react-barcode-reader";
import { useTranslation } from "react-i18next";
import AsyncSelect from "react-select/async";
import { StringUtils } from "../../../../utils/StringUtils";
import { SyncUtils } from "../../../../utils/SyncUtils";
import { SaleUtils } from "../../../../utils/SaleUtils";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export default function PurchaseRequestDraftList(props) {
  const { t } = useTranslation();
  const translate = t;
  const [prodLookupValue, setProdLookupValue] = useState();
  const [isConsolidated, setConsolidated] = useState(true);
  const [dataTableHeight, setDataTableHeight] = useState(0);

  props.biRef.requestDraftList = {
    parentEvent: parentEvent,
  };

  const valType = [
    "SN",
    "PRODUCT_NAME",
    "UNIT",
    "QTY",
    "foc",
    "COST",
    "TAX_PER",
    "TAX_COST",
    "COST_WITHOUT_TAX",
    "FINAL_COST",
  ];

  useEffect(() => {
    /*Dynamic screen height adjustment*/
    function handleResize() {
      setDataTableHeight(getWindowDimensions().height - 320);
    }
    setDataTableHeight(getWindowDimensions().height - 320);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    scollToActiveElem();
  }, [props.data]);

  function scollToActiveElem() {
    let i = 0;
    for (var e of props.data) {
      if (e[10].info.selected) {
        const timer = setTimeout(() => {
          const node = document.getElementById("pr_table_row_" + (i - 1));
          if (node) node.scrollIntoView();
          else {
            const node = document.getElementById("pr_table_row_" + i);
            if (node) node.scrollIntoView();
          }
        }, 25);
        return () => clearTimeout(timer);
      }
      i++;
    }
  }

  function parentEvent(eventType) {
    if (eventType == "isTaxEnabled") return props.isWithTax;
  }

  function updateData(eventSource, meta, value, index) {
    if (eventSource === "table") {
      let dat = [...meta.tableData];
      updatevalues(
        dat[meta.rowIndex],
        valType[meta.columnIndex],
        value,
        meta.columnIndex
      );
      props.updatePurchaseItemData(dat);
    }
    /*if (eventSource === "crud") {

    }*/
  }

  function updatevalues(rowData, valType, value, colIndex) {
    if (colIndex != null) rowData[colIndex] = value;

    let receivedQty = 0;
    let foc = {};
    let receivedCost = 0;
    let taxPercentage = 0;
    let taxCost = 0;
    let costWithoutTax = 0;
    let finalCost = 0;

    if (rowData[3]) receivedQty = rowData[3].v;
    if (rowData[5]) receivedCost = rowData[5].v;
    if (rowData[6]) taxPercentage = rowData[6].v;
    if (rowData[7]) taxCost = rowData[7].v;
    if (rowData[8]) costWithoutTax = rowData[8].v;
    if (rowData[9]) finalCost = rowData[9].v;

    if (valType == "QTY") {
      receivedQty = value.v;
      receivedCost = receivedCost == null ? 0 : receivedCost;
      costWithoutTax = receivedQty * receivedCost;

      if (props.taxType.id == "1") {
        /*Include Tax*/
        taxPercentage = taxPercentage == null ? 0 : taxPercentage;
        taxCost =
          (parseFloat(costWithoutTax) * parseFloat(taxPercentage)) /
          (100 + parseFloat(taxPercentage));
        finalCost = costWithoutTax;
        costWithoutTax = costWithoutTax - taxCost;
      } else if (props.taxType.id == "2") {
        /*Exclude Tax*/
        taxPercentage = taxPercentage == null ? 0 : taxPercentage;
        taxCost = (costWithoutTax * taxPercentage) / 100;
        finalCost = taxCost + costWithoutTax;
      } else {
        finalCost = costWithoutTax;
        taxCost = 0;
      }
    } else if (valType == "foc") {
      foc = value.v;
      receivedQty = receivedQty == null ? 0 : receivedQty;
    } else if (valType == "COST") {
      receivedCost = value.v;
      receivedQty = receivedQty == null ? 0 : receivedQty;
      costWithoutTax = receivedQty * receivedCost;

      if (props.taxType.id == "1") {
        /*Include Tax*/
        taxPercentage = taxPercentage == null ? 0 : taxPercentage;
        taxCost =
          (parseFloat(costWithoutTax) * parseFloat(taxPercentage)) /
          (100 + parseFloat(taxPercentage));
        finalCost = costWithoutTax;
        costWithoutTax = costWithoutTax - taxCost;
      } else if (props.taxType.id == "2") {
        /*Exclude Tax*/
        taxPercentage = taxPercentage == null ? 0 : taxPercentage;
        taxCost = (costWithoutTax * taxPercentage) / 100;
        finalCost = taxCost + costWithoutTax;
      } else {
        finalCost = costWithoutTax;
        taxCost = 0;
      }
    } else if (valType == "TAX_CHANGE") {
      receivedQty = receivedQty == null ? 0 : receivedQty;
      receivedCost = receivedCost == null ? 0 : receivedCost;
      costWithoutTax = receivedQty * receivedCost;
      taxCost = 0;
      if (value.id == "1") {
        /*Include Tax*/
        taxPercentage = taxPercentage == null ? 0 : taxPercentage;
        taxCost =
          (parseFloat(costWithoutTax) * parseFloat(taxPercentage)) /
          (100 + parseFloat(taxPercentage));
        finalCost = costWithoutTax;
        costWithoutTax = costWithoutTax - taxCost;
      } else if (value.id == "2") {
        /*Exclude Tax*/
        taxPercentage = taxPercentage == null ? 0 : taxPercentage;
        taxCost = (costWithoutTax * taxPercentage) / 100;
        finalCost = taxCost + costWithoutTax;
      } else finalCost = costWithoutTax;
    }
    setVal(rowData, 3, receivedQty, valType, "QTY");
    setVal(rowData, 4, foc, valType, "foc");
    setVal(rowData, 5, receivedCost, valType, "COST");
    setVal(rowData, 6, taxPercentage, valType, "TAX_PER");
    setVal(rowData, 7, taxCost, valType, "TAX_COST");
    setVal(rowData, 8, costWithoutTax, valType, "COST_WITHOUT_TAX");
    setVal(rowData, 9, finalCost, valType, "FINAL_COST");
  }

  function setVal(rowData, index, value, valType, dataType) {
    if (valType === dataType) {
      if (dataType === "foc") {
        rowData[index] = { v: { foc: value.foc, focQty: value.focQty } };
      } else rowData[index] = { v: value, e: "" };
    } else if (dataType === "foc") {
      rowData[index] = {
        v: {
          foc: value.foc,
          focQty: value.focQty,
        },
      };
    } else {
      if (isFinite(value)) {
        rowData[index] = {
          v: StringUtils.formattedNumberWithStoreDecimal(value, props.context),
          e: "",
        };
      } else {
        rowData[index] = { v: "", e: "" };
      }
    }
  }

  const columns = [
    {
      name: "serialNumber",
      label: translate("SN"),
      options: {
        filter: false,
        sort: false,
        /*customHeadLabelRender: (value, tableMeta, updateValue) => (
          <div style={{ textAlign: "left", paddingLeft: 5 }}>SN</div>
        ),*/
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 30 }}>{value.v}</div>
        ),
      },
    },
    {
      name: "productName",
      label: translate("Product Name"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div id={"pr_table_row_" + tableMeta.rowIndex} style={{ width: 300 }}>
            {value.v}
          </div>
        ),
      },
    },
    {
      name: "unit",
      label: translate("Unit"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 60 }}>{value.v}</div>
        ),
      },
    },
    {
      name: "qty",
      label: translate("Quantity"),
      options: {
        filter: false,
        sort: false,
        display: "true",

        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 100 }}>
            <PText
              value={value.v}
              type="number"
              onChange={(e) =>
                updateData(
                  "table",
                  tableMeta,
                  e.target.value
                    ? { v: e.target.value, e: "" }
                    : { v: "", e: "" }
                )
              }
            ></PText>
          </div>
        ),
      },
    },
    {
      name: "foc",
      label: translate("FOC QTY"),
      options: {
        filter: false,
        sort: false,
        display: "false",

        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 120 }}>
            <table>
              <tbody>
                <tr>
                  <td>
                    <PCheck
                      value={value.v.foc}
                      onChange={(e) =>
                        updateData("table", tableMeta, {
                          v: { foc: e, focQty: 0 },
                        })
                      }
                    ></PCheck>
                  </td>
                  <td>
                    <PText
                      style={{ width: 30 }}
                      value={value.v.focQty}
                      type="number"
                      onChange={(e) =>
                        updateData("table", tableMeta, {
                          v: { foc: value.v.foc, focQty: e.target.value },
                        })
                      }
                      InputProps={{ readOnly: !value.v.foc }}
                    ></PText>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ),
      },
    },
    {
      name: "cost",
      label: translate("Cost"),
      options: {
        filter: false,
        sort: false,
        display: "true",

        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 100 }}>
            <PText
              value={value.v}
              type="number"
              onChange={(e) =>
                updateData(
                  "table",
                  tableMeta,
                  e.target.value
                    ? { v: e.target.value, e: "" }
                    : { v: "", e: "" }
                )
              }
            ></PText>
          </div>
        ),
      },
    },
    {
      name: "taxPercentage",
      label: translate("Tax %"),
      options: {
        filter: false,
        sort: false,
        display: "true",

        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 60 }}>
            <PText
              value={value.v}
              type="number"
              onChange={(e) =>
                updateData(
                  "table",
                  tableMeta,
                  e.target.value
                    ? { v: e.target.value, e: "" }
                    : { v: "", e: "" }
                )
              }
              InputProps={{
                readOnly: true,
              }}
            ></PText>
          </div>
        ),
      },
    },
    {
      name: "taxCost",
      label: translate("Tax Cost"),
      options: {
        filter: false,
        sort: false,
        display: "true",

        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 80 }}>
            <PText
              value={value.v}
              type="number"
              onChange={(e) =>
                updateData(
                  "table",
                  tableMeta,
                  e.target.value
                    ? { v: e.target.value, e: "" }
                    : { v: "", e: "" }
                )
              }
              InputProps={{
                readOnly: true,
              }}
            ></PText>
          </div>
        ),
      },
    },
    {
      name: "costWIthoutTax",
      label: translate("Cost without Tax"),
      options: {
        filter: false,
        sort: false,
        display: "true",

        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 100 }}>
            <PText
              value={value.v}
              type="number"
              onChange={(e) =>
                updateData(
                  "table",
                  tableMeta,
                  e.target.value
                    ? { v: e.target.value, e: "" }
                    : { v: "", e: "" }
                )
              }
              InputProps={{
                readOnly: true,
              }}
            ></PText>
          </div>
        ),
      },
    },
    {
      name: "finalCost",
      label: translate("Final Cost"),
      options: {
        filter: false,
        sort: false,
        display: "true",

        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ width: 100 }}>
            <PText
              value={value.v}
              type="number"
              onChange={(e) =>
                updateData(
                  "table",
                  tableMeta,
                  e.target.value
                    ? { v: e.target.value, e: "" }
                    : { v: "", e: "" }
                )
              }
              InputProps={{
                readOnly: true,
              }}
            ></PText>
          </div>
        ),
      },
    },
    {
      name: "action",
      label: translate("Action"),
      options: {
        filter: false,
        sort: false,
        display: props.viewMode == "view" ? "false" : "true",
        customBodyRender: (value, tableMeta, updateValue) => (
          <div style={{ textAlign: "right" }}>
            <Tooltip title={translate("Remove Pricing")}>
              <IconButton
                color="secondary"
                onClick={() =>
                  onRemoveItemClicked(tableMeta, updateValue, value)
                }
              >
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </div>
        ),
      },
    },
  ];

  function onRemoveItemClicked(tableMeta, updateValue, value) {
    let data = [...tableMeta.tableData];
    data.splice(tableMeta.rowIndex, 1);
    let index = 0;
    data.map((item) => {
      data[index][0].v = index + 1;
      index++;
    });
    resetSelection(data, tableMeta.rowIndex);
    props.updatePurchaseItemData(data);
  }

  const formatOptionLabel = (option, { context }) => {
    if (context === "menu") {
      return (
        <Grid container>
          <Grid item xs={3}>
            {option.value.unitType}
          </Grid>
          <Grid item xs={6}>
            {option.value.name}
          </Grid>
          <Grid item xs={3}>
            {option.value.price}
          </Grid>
        </Grid>
      );
    }
    if (!option.label) return "";
    return option.label.name;
  };

  const options = {
    textLabels: {
      body: {
        noMatch: translate("Search or Scan the product"),
      },
    },
    filterType: "checkbox",
    filter: false,
    search: false,
    print: false,
    download: false,
    viewColumns: false,
    customToolbar: false,
    title: false,
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    tableBodyMaxHeight: "100%",
    tableBodyHeight: dataTableHeight,
    pagination: false,
    responsive: "standard",
    setRowProps: (row, dataIndex, rowIndex) => {
      if (props.data.length > 0 && props.data[rowIndex][10].info.selected) {
        return {
          style: { background: "#fffbc4" },
        };
      }
    },
    /*onRowClick: (rowData, rowMeta, rowIndex) => {
    },*/
    onCellClick: (colData, cellMeta) => {
      if (cellMeta.colIndex != 10) {
        var data = [...props.data];
        resetSelection(props.data, cellMeta.rowIndex);
        props.updatePurchaseItemData(data);
      }
    },
  };

  function resetSelection(data, rowIndex) {
    for (let i = 0; i < data.length; i++) {
      if (rowIndex == i) data[i][10].info.selected = true;
      else data[i][10].info.selected = false;
    }
  }

  const getOptions = (inputValue, callback) => {
    getOptionsAsync(inputValue, callback);
  };

  async function getOptionsAsync(inputValue, callback) {
    let arr = await SyncUtils.searchInCache(
      props.productCache,
      inputValue,
      100
    );
    return callback(
      arr.map(function (option, index) {
        return {
          value: option,
          label: option,
        };
      })
    );

    //return callback([]);
  }

  function getItemIndex(productId, itemList) {
    let index = null;
    for (let i = 0; i < itemList.length; i++) {
      if (itemList[i][10].info.productBean.id == productId) {
        index = i;
        break;
      }
    }
    return index;
  }

  function updatePurchaseItemQty(itemList, index, newValue) {
    let receivedQty = 0;
    let foc = {};
    let receivedCost = 0;
    let taxPercentage = 0;
    let taxCost = 0;
    let costWithoutTax = 0;
    let finalCost = 0;

    if (itemList[index][3]) receivedQty = parseFloat(itemList[index][3].v);
    if (itemList[index][4]) foc = parseFloat(itemList[index][4].v);
    if (itemList[index][5]) receivedCost = parseFloat(itemList[index][5].v);
    if (itemList[index][6]) taxPercentage = parseFloat(itemList[index][6].v);
    if (itemList[index][7]) taxCost = parseFloat(itemList[index][7].v);
    if (itemList[index][8]) costWithoutTax = parseFloat(itemList[index][8].v);
    if (itemList[index][9]) finalCost = parseFloat(itemList[index][9].v);

    receivedQty = receivedQty + newValue;
    receivedCost = receivedCost == null ? 0 : receivedCost;
    costWithoutTax = receivedQty * receivedCost;

    if (props.isWithTax) {
      taxPercentage = taxPercentage == null ? 0 : taxPercentage;
      taxCost = (costWithoutTax * taxPercentage) / 100;
      finalCost = taxCost + costWithoutTax;
    } else {
      finalCost = costWithoutTax;
      taxCost = 0;
    }

    let orderItem = [
      { v: itemList[index][0].v },
      { v: itemList[index][1].v },
      { v: itemList[index][2].v },
      { v: receivedQty },
      { v: foc },
      { v: receivedCost },
      {
        v: itemList[index][6].v,
      },
      { v: taxCost },
      { v: costWithoutTax },
      { v: finalCost },
      {
        info: itemList[index][10].info,
      },
    ];

    itemList[index] = orderItem;
    resetSelection(itemList, index);
    props.updatePurchaseItemData(itemList);
  }

  async function addProductToTable(productBean, pricingBean) {
    var data = [...props.data];
    let itemIndex = getItemIndex(productBean.id, data);
    if (itemIndex != null && isConsolidated) {
      updatePurchaseItemQty(data, itemIndex, 0);
    } else {
      let sn = data.length + 1;
      let derivedCost = pricingBean.cost;
      if (props.taxType.id == "1") {
        derivedCost = StringUtils.formattedNumber(
          parseFloat(derivedCost) +
            parseFloat(derivedCost) *
              (parseFloat(productBean.taxBean.rate) / 100),
          props.context.store.currencyDecimal
        );
      }
      let orderItem = [
        { v: sn },
        { v: productBean.name },
        { v: pricingBean.unitType },
        { v: 0 },
        { v: { foc: false, focQty: 0 } },
        { v: derivedCost },
        {
          v:
            productBean.taxBean != null &&
            (productBean.taxBean != null) != undefined
              ? productBean.taxBean.rate
              : "0",
        },
        { v: "0" },
        { v: "0" },
        { v: "0" },
        {
          info: {
            productBean: productBean,
            pricingBean: pricingBean,
            selected: false,
          },
        },
      ];
      data.push(orderItem);
      resetSelection(data, data.length - 1);
      props.updatePurchaseItemData(data);
    }
  }

  const productLookupChanged = (newValue) => {
    prodSelected(newValue);
  };

  async function prodSelected(newValue) {
    let [prodBean, pricingBean] = await SyncUtils.getProductBean(
      newValue.value
    );
    if (prodBean == null || pricingBean == null) {
      alert("Product got Deleted or Modifed, please Reload the Window");
    } else {
      await addProductToTable(prodBean, pricingBean);
    }
    setProdLookupValue({ label: null, value: null });
  }

  function handleWIthTaxChangeEvent(value) {
    props.setTaxType(value);
    let datList = [...props.data];
    for (let i = 0; i < datList.length; i++) {
      updatevalues(datList[i], "TAX_CHANGE", value, null);
    }
    props.updatePurchaseItemData(datList);
  }

  function rejectdBarcode(barcode) {
    console.log("Rejected Barcode :", barcode);
  }

  function onBarcodeScanned(barcode) {
    console.log("Scuccess Barcode :", barcode);
    findProductByBarcode(barcode);
  }

  function getPricingFromBarcode(productBean, barcode) {
    for (let pricing of productBean.productPricingBeanList) {
      for (let barcodeBean of pricing.productBarcodeBeanList) {
        if (barcodeBean.barcode == barcode) {
          return pricing;
        }
      }
    }
  }

  async function findProductByBarcode(barcode) {
    let dbData = await db.product
      .where("barcodeList")
      .equals(barcode)
      .toArray();
    if (dbData.length == 0) {
      props.showMessage("warning", "Product Not Found");
    } else {
      let productBean = dbData[0];
      let pricingBean = getPricingFromBarcode(productBean, barcode);
      await addProductToTable(productBean, pricingBean);
    }
  }

  return (
    <div>
      <BarcodeReader
        onError={rejectdBarcode}
        onScan={onBarcodeScanned}
        preventDefault={true}
        avgTimeByChar={
          props.context.storeAdmin.barcodeScanAvgTimeByChar
            ? props.context.storeAdmin.barcodeScanAvgTimeByChar
            : 30
        }
      ></BarcodeReader>
      <Grid container>
        <Grid item xs={12} sm={12}>
          <table width="100%">
            <tr>
              <td width="65%">
                <AsyncSelect
                  formatOptionLabel={formatOptionLabel}
                  components={{ formatOptionLabel }}
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 99999,
                    }),
                    marginRight: "10px",
                  }}
                  placeholder={translate("Product Lookup")}
                  loadOptions={getOptions}
                  onChange={productLookupChanged}
                  onKeyDown={(e) => {
                    e.stopPropagation();
                    e.nativeEvent.stopImmediatePropagation();
                  }}
                  //options={cities}
                />
              </td>{" "}
              <td width="3%">
                <PCheck
                  onChange={(value) => setConsolidated(value)}
                  checked={isConsolidated}
                  label={translate("Consolidated")}
                ></PCheck>
              </td>
              <td width="15%">
                <PSelect
                  options={props.taxTypeOptions}
                  value={props.taxType}
                  onChange={(event, newValue) => {
                    handleWIthTaxChangeEvent(newValue);
                  }}
                ></PSelect>
              </td>
            </tr>
          </table>
        </Grid>
        <Grid item xs={12} sm={12}>
          <MUIDataTable data={props.data} columns={columns} options={options} />
        </Grid>
      </Grid>
    </div>
  );
}
